export const Company = (data) => ({
  id: data.id,
  source: data.attributes.source,
  sourceId: data.attributes.source_id,
  name: data.attributes.name,
  logoUrl: data.attributes.logo_url,
  aiInsightsEnabled: data.attributes.ai_insights_enabled,
});

export const CompaniesList = (data) => data.map(Company);
